export default __webpack_public_path__ + "static/carousel4-e3201dc18a8f162cd94deb736cb266f6.png";